import { Text } from '@mantine/core';
import * as React from 'react';

import FieldSelect from '@/components/shared/form/FieldSelect';
import { FieldSelectStore } from '@/stores/local/shared/form/FieldSelectStore';
import { DocumentSourceTypeSelectStore } from '@/stores/local/sidebar/SidebarDocumentsStore/PopupsStore/UploadDocumentPopupStore/DocumentSourceTypeSelectStore';

export type SourceSelectProps = {
  store: DocumentSourceTypeSelectStore;
  disabled?: boolean;
  className?: string;
};

const SourceSelect: React.FC<SourceSelectProps> = ({ store, disabled, className }) => (
  <FieldSelect
    className={className}
    label={
      <Text span size="sm">
        Источник
      </Text>
    }
    fw="400"
    placeholder="Выберите источник"
    store={store as FieldSelectStore}
    disabled={disabled}
    withSearch={false}
    size="sm"
  />
);

export default React.memo(SourceSelect);
